import React from 'react';
import Styles from '../styles/ConfirmModal.module.css';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Delete',
  cancelText = 'Cancel',
  type = 'danger' 
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className={Styles.overlay} onClick={onClose}>
      <div className={Styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={Styles.header}>
          <div className={Styles.icon}>
            {type === 'danger' && '⚠️'}
            {type === 'warning' && '⚠️'}
            {type === 'info' && 'ℹ️'}
          </div>
          <h2 className={Styles.title}>{title}</h2>
        </div>
        
        <div className={Styles.body}>
          <p className={Styles.message}>{message}</p>
        </div>
        
        <div className={Styles.footer}>
          <button 
            className={Styles.cancel_button} 
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button 
            className={`${Styles.confirm_button} ${Styles[type]}`}
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
